import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';


@Injectable({ providedIn: 'root' })
export class MenuService {

  private subject = new Subject<any>();

     toggleMenu() {
        this.subject.next();
    }

    getMenu(): Observable<any> {
        return this.subject.asObservable();
    }
   
}